

























































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
    MantenedorGrid,
  },
})
export default class ModalVerEstadoSeries extends Vue {
  @Prop({ required: true }) compranumero: any;

  ordesList: any;

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      {
        compra: this.compranumero,
      },
      'conectaOrdenesCompra/get_estados_equipos'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar los equipos', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getEquipos();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  gridOptions: GridOptions;

  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY-MM-DD HH:mm');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Serie',
        field: 'serienumero',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'IMEI',
        field: 'serieimei',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Estado Inet',
        field: 'estado_inet',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
      },
      {
        headerName: 'Respuesta Inet',
        field: 'glosa_inet',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
      },
      {
        headerName: 'Estado CRM',
        field: 'estado_crm',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
      },
      {
        headerName: 'Respuesta CRM',
        field: 'glosa_crm',
        resizable: true,
        sortable: true,
        width: 300,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  mounted() {}

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  //abstract;

  //propiedades globales
  loadingService = new LoadingService();
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  setBotonNav() {}

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal() {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
  }

  confirmCallback(val: any) {}
}
